<script lang="ts">
  import { debounce } from "lodash";
  import type { IntegrationDetails } from "../../helpers/types";
  import StepSuccessIcon from "./StepSuccessIcon.svelte";
  import { saveNotificationEmail, getIntegrations } from "../../helpers/integrations-api";
  import { onMount } from "svelte";
  import { track } from "../../helpers/mixpanel";

  import { setSetupStep, setupStepStore } from "../../stores/integrations-store";
  import { selectedBuyer } from "../../stores/buyer";

  export let integration: IntegrationDetails;
  export let stepNumber: number = 0;
  export let isActive: boolean = false;
  export let currentStep: number = 0;
  export let authenticated: boolean = false;

  let addressInputs: HTMLInputElement[] = [];

  $: active = (stepNumber && authenticated && isActive) || (authenticated && !stepNumber);

  $: valid = false;

  let emails = integration?.error_emails || [""];

  onMount(() => {
    valid = integration.error_emails?.length && integration.error_emails[0] ? true : false;
  });

  const addEmailField = () => {
    if (emails[emails.length - 1]) {
      emails = [...emails, ""];
    }
  };

  const handleEmailUpdate = debounce((e, i) => {
    emails[i] = e.target.value;

    emails = emails.length > 1 ? emails.filter((email) => email) : emails;

    track("integration_email_update_field", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      value: emails,
      is_setup: !stepNumber,
    });
    {
      if (!addressInputs[i].value || addressInputs[i].checkValidity())
        saveNotificationEmail(emails, integration.id).then((result: any) => {
          if (result) {
            valid = true;
            integration.error_emails = emails;
            setSetupStep(integration, true);
            getIntegrations(integration.buyer_id);
          }
        });
    }
  }, 300);
</script>

<div class="container">
  <div class="supply-line-header">
    <StepSuccessIcon success={authenticated && valid} {isActive} {stepNumber} />
    <h4 class="subtitle">add accountant's email</h4>
    {#if (!active && authenticated && currentStep >= stepNumber - 1) || (!active && authenticated && valid)}
      <button class="contact-us-btn btn-neutral" on:click={() => setupStepStore.set(stepNumber)}
        >edit
      </button>
    {/if}
  </div>
  {#if active}
    <div class="content">
      {#each emails as email, i}
        <div class="row">
          <input
            name={`email_${i}`}
            placeholder="accountantemail@example.com"
            bind:this={addressInputs[i]}
            required
            on:input={(e) => handleEmailUpdate(e, i)}
            class="email-input"
            type="email"
            value={email}
          />
          {#if i === emails.length - 1}
            <div class="plus_icon_container">
              <button
                class="plus_icon_btn"
                on:click={() => {
                  addEmailField();
                }}
              >
                <img class="plus_icon" alt={`plus icon`} src="static/assets/icons/icon-plus.svg" />
              </button>
            </div>
          {/if}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .container {
    border-radius: 8px;
    background-color: white;
    margin-bottom: 18px;
  }

  .supply-line-header {
    display: flex;
    padding: 18px;
    border-bottom: 1px solid;
    border-color: var(--rekki-neutral-01);
    align-items: center;
  }
  .content {
    padding: 18px;
    display: flex;
    position: relative;
    flex-direction: column;
  }

  .row {
    display: flex;
    padding: 8px 0;
  }

  .subtitle {
    font-size: 18px;
    font-weight: bold;
  }

  .email-input {
    background-color: var(--rekki-neutral-01);
    height: 60px;
    flex: 1;
    border-radius: 8px;
    border: none;
    font-size: 18px;
    padding: 0 12px;
  }

  .contact-us-btn {
    border-radius: 100px;
    padding: 10px 20px;
    background-color: var(--rekki-accent);
    color: var(--rekki-light);
    border: none;
    justify-self: flex-end;
    font-family: "REKKI-OCD";
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: auto;
    font-size: 16px;
  }

  .btn-neutral {
    background-color: var(--rekki-neutral-01);
    color: var(--rekki-dark);
  }

  .plus_icon_container {
    position: absolute;
    height: 20px;
    display: flex;
    align-items: baseline;
    padding: 14px 27px 0px 0px;
    justify-content: flex-end;
    right: 0;
  }

  .plus_icon_btn {
    all: unset;
  }

  .plus_icon {
    padding: 10px;
    cursor: pointer;
  }
</style>
